import { useRouter } from 'next/router'
import { InternalLink } from '../src/const/Links'

export function useLocalizedSignIn() {
	const router = useRouter()

	const signIn = () => {
		router.push({ pathname: InternalLink.Login, query: { callbackUrl: window.location.href } })
	}

	return { signIn }
}
